/** ---------------------------------------------------------------------------------------
 * --  LICENSE AGREEMENT -- *
 This software is licensed under the following terms:

 * -- GRANT OF LICENSE | RESTRICTIONS -- *
 Subject to the terms and conditions of this license, the copyright holders
 hereby grant you a non-exclusive, non-transferable, revocable license to use,
 copy, modify, and distribute the software.
 You are expressly prohibited from selling or commercially exploiting the software.
 Unauthorized use, reproduction, or distribution of the software, or any part
 thereof, is strictly prohibited.

 * -- AUTHORIZED USERS | INTELLECTUAL PROPERTY -- *
 This license is granted only to the individual or entity to whom the software is
 directly distributed by the copyright holders. Any use by other individuals or
 entities is unauthorized and in violation of this license. The software is
 protected by copyright and other intellectual property laws.
 The copyright holders retain all rights, title, and interest in the software.

 * -- GOVERNING LAW -- *
 This license is governed by and construed in accordance with the laws of Romania.
 Any legal action or proceeding related to this license shall be brought exclusively
 in the courts of Romania.

 [Weddify x Diaphan Stationery] © [2024] All rights reserved.
 -------------------------------------------------------------------------------------- **/

import React, {useEffect, useState} from 'react';
import {PiHandTapThin} from "react-icons/pi";
import Skeleton from "react-loading-skeleton";
import Link from "next/link";
import {apiMediaUrl, apiThemeUploadPath} from '../../utils/AppConfig';
import {useGetThemesQuery} from "../../services/themesApi";
import 'react-loading-skeleton/dist/skeleton.css'

const AppThemes = () => {
    const [initialLoading, setInitialLoading] = useState(false);
    const uploadPath = apiMediaUrl + apiThemeUploadPath;

    const {
        data: themes,
        isFetching,
        isLoading,
        isSuccess
    } = useGetThemesQuery();

    const loading = isFetching || isLoading;
    const successFetch = isSuccess;

    useEffect(() => {
        if (successFetch && !initialLoading) {
            setInitialLoading(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [successFetch]);

    if (loading && !initialLoading) {
        return (
            <>
                <Skeleton count={1} height={120}/>
                <Skeleton count={1} height={120}/>
                <Skeleton count={1} height={200}/>
            </>
        )
    }

    return (
        <>
            {themes && (
                <div className="app-themes">
                    <div className="grid grid-cols-1">
                        <>
                            {themes.filter((theme: any) => theme.themeType === 'wedding').map((theme: any, index: number) => (
                                <Link href={`/w${theme.previewURL}`}
                                      target="_blank"
                                      key={index}
                                      className="flex relative cursor-pointer rounded-3xl bg-center bg-cover bg-no-repeat min-h-[200px] justify-start -mb-[50px] hover:mb-0 hover:min-h-[300px] hover:ease-in-out transition-all duration-300"
                                      style={{backgroundImage: `url(${uploadPath}${theme.thumbnail})`}}
                                >
                                    <div
                                        className="rounded-2xl h-[60px] font-bold tracking-widest text-lg ml-2 mt-2 bg-white p-4">
                                        {theme.name}
                                    </div>
                                    <div
                                        className="rounded-2xl font-bold text-lg bg-white p-4 absolute top-2 right-2">
                                        <PiHandTapThin className="text-2xl"/>
                                    </div>
                                </Link>
                            ))}
                            {themes.filter((theme: any) => theme.themeType === 'baptism').map((theme: any, index: number) => (
                                <Link href={`/w${theme.previewURL}`}
                                      target="_blank"
                                      key={index}
                                      className="flex relative cursor-pointer rounded-3xl bg-center bg-cover bg-no-repeat min-h-[200px] justify-start -mb-[50px] hover:mb-0 hover:min-h-[300px] hover:ease-in-out transition-all duration-300"
                                      style={{backgroundImage: `url(${uploadPath}${theme.thumbnail})`}}
                                >
                                    <div
                                        className="rounded-2xl h-[60px] font-bold tracking-widest text-lg ml-2 mt-2 bg-white p-4">
                                        {theme.name}
                                    </div>
                                    <div
                                        className="rounded-2xl font-bold text-lg bg-white p-4 absolute top-2 right-2">
                                        <PiHandTapThin className="text-2xl"/>
                                    </div>
                                </Link>
                            ))}
                        </>
                    </div>
                </div>
            )}
        </>
    )
}

export default AppThemes;
